<!--领取成功弹窗-->
<template>
  <el-dialog
    :visible.sync="visible"
    title="提示"
    width="30%"
    :modal-append-to-body="false"
  >
    <span>{{config.content}}</span>
    <span slot="footer" class="dialog-footer">
    <el-button v-if="config.btnCancelText.length > 0" @click="cancel">{{config.btnCancelText}}</el-button>
    <el-button type="primary" @click="confirm">{{config.btnConfirmText}}</el-button>
  </span>
  </el-dialog>

</template>

<script>
export default {
  name: 'SVersionDialogTip',
  components: {
  },
  props: {
  },
  data () {
    return {
      visible: false,
      config: {
        title: '提示',
        content: '',
        btnConfirmText: '确定',
        btnCancelText: '取消',
        onConfirm: () => {},
        onCancel: () => {}
      }
    }
  },
  inject: {
    // 由 FiveWrap 组件传入
    $MainWrap: {
      default: () => null
    }
  },
  computed: {
  },
  methods: {
    async open (options) {
      this.config = Object.assign({
        title: '提示',
        content: '',
        btnConfirmText: '确定',
        btnCancelText: '取消',
        onConfirm: () => {},
        onCancel: () => {}
      }, options)
      this.visible = true
    },
    confirm () {
      this.config.onConfirm()
      this.close()
    },
    cancel () {
      this.config.onCancel()
      this.close()
    },
    close () {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
